import { pickBy } from "lodash";
import { DataTableSortStatus } from "mantine-datatable";

import {
  TradeInsuranceFilter,
  TradeInsuranceOrderBy,
} from "../../graphql/generated.ts";
import { getApiOrderBy } from "../../utils/api.ts";
import { FiltersValue } from "./types.ts";

export const getTradeInsuranceApiSort = (
  tableSort: DataTableSortStatus
): TradeInsuranceOrderBy => {
  const { customerName, ...apiSort } = getApiOrderBy(tableSort);
  return {
    ...apiSort,
    customer: customerName && { name: customerName },
  };
};

export const getTradeInsuranceApiFilter = (
  filter: FiltersValue
): TradeInsuranceFilter => {
  return pickBy({
    customerId: filter.customerId?.length && {
      in: filter.customerId.map((c) => Number(c)),
    },
    insuranceName: filter.insuranceName && {
      contains: filter.insuranceName,
      mode: "insensitive",
    },
    status: filter.status && { equals: filter.status },
  });
};
